import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SuccessDisplayService {
  private readonly _showSuccessMessage = signal(false);
  readonly showSuccessMessage = this._showSuccessMessage.asReadonly();

  timeout = 5000;

  showMessage() {
    this._showSuccessMessage.set(true);

    setTimeout(() => {
      this._showSuccessMessage.set(false);
    }, this.timeout);
  }
}
